import clsx from "clsx";
import Button from "components/Button";
import Modal from "components/Modal";
import { strings } from "constants/strings";
import { InformationFormData } from "models/HaulPay";
import { useFormContext } from "react-hook-form";
import DollarInput from "components/DollarInput";

type EnterAdvanceAmountModalProps = {
  isOpen: boolean;
  toggleModalOpen: VoidFunction;
  totalToBePaidAmount: number;
  onConfirm: VoidFunction;
  onDecline: VoidFunction;
};

export default function EnterAdvanceAmountModal({
  isOpen,
  toggleModalOpen,
  totalToBePaidAmount,
  onConfirm,
  onDecline
}: Readonly<EnterAdvanceAmountModalProps>) {
  const {
    watch,
    formState: { errors }
  } = useFormContext<InformationFormData>();
  const advanceAmount = watch("advanceAmount");

  return (
    <Modal
      isOpen={isOpen}
      closeModal={toggleModalOpen}
      wrapperClass="!my-auto desktop:!min-h-fit desktop:!w-1/2 text-sm"
      dialogClass="!bg-foreground !px-3 !pb-4 !pt-12 gap-5"
      closeClass="!top-24 !right-6 !bg-transparent !text-text">
      <div className="flex flex-col gap-3 pr-4">
        <span>{strings.CARRIER_FR.ALREADY_TAKE_ADVANCE_FROM_CUSTOMER}</span>
        <DollarInput
          name="advanceAmount"
          error={errors.advanceAmount}
          placeholder="Enter advance amount here"
        />
        <p>
          Total to be paid: <span className="font-bold">${totalToBePaidAmount.toFixed(2)}</span>
        </p>
      </div>
      <div className="flex justify-between gap-1">
        <Button variant="outline" rounded className="!w-32 text-sm !h-9" onClick={onDecline}>
          No
        </Button>
        <Button
          rounded
          className={clsx(
            "!w-32 text-sm !h-9",
            advanceAmount
              ? "bg-gradient-to-r from-primary to-secondary"
              : "!bg-subtitle !ring-subtitle cursor-not-allowed"
          )}
          disabled={!advanceAmount}
          onClick={onConfirm}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
}
